/* eslint-disable @typescript-eslint/no-unused-vars */
import { InputWithLabel, SelectWithLabel } from '@adotel/components'
import { DateObject } from '@adotel/components/build/helpers/date'
import { useLazyQuery } from '@apollo/client'
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  Checkbox,
  Typography,
  TextField
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'

import { ITTIC_REERVATION_TYPES } from '../../../../graphql/tenant'
import { combineDateTime } from '../../../../helpers/date'
import {
  elevenNumbersOnlyRegex,
  englishRegex,
  iranMobileRegex,
  persianLetterRegex,
  persianRegex,
  tenNumbersOnlyRegex
} from '../../../../helpers/regex'
import { getTranslate, lang } from '../../../../localization'
import { ConfirmPrimitiveReservationInput } from '../../../../types/cart'
import { ItticReservationType } from '../../../../types/tenants'
import { validateIdentificationNo } from './helper'
import { useStyles } from './styles/index.styles'

type BookerDetailsFormProps = {
  confirmPrimitiveInput: ConfirmPrimitiveReservationInput
  setConfirmPrimitiveInput: React.Dispatch<
    React.SetStateAction<ConfirmPrimitiveReservationInput>
  >

  setOptionReservationExpiry: React.Dispatch<React.SetStateAction<boolean>>
  optionReservationExpiry: boolean
  setFillBookerDetalisEnabled: React.Dispatch<React.SetStateAction<boolean>>
  showDiscount: boolean
  showOtionReserveExpiryTime: boolean
  showReservationType: boolean
  optionReserveMaxExpireTime: string
}

const BookerDetailsForm = ({
  confirmPrimitiveInput,
  setConfirmPrimitiveInput,
  setFillBookerDetalisEnabled,
  showDiscount,
  showReservationType,
  optionReserveMaxExpireTime
}: BookerDetailsFormProps) => {
  const classes = useStyles()
  const [dateObject, setdateObject] = useState<DateObject>({})
  const [time, setTime] = useState('10:00')

  useEffect(() => {
    if (dateObject.gregorianStartDate && time) {
      const expiry = combineDateTime(dateObject.gregorianStartDate, time)
      setConfirmPrimitiveInput({ ...confirmPrimitiveInput, expiresAt: expiry })
    }
  }, [dateObject, time])

  //ITTIC_RESERVATION_TYPES_QUERY
  const [getItticReservationTypes, { data: itticReservationTypes }] =
    useLazyQuery<{
      getItticReservationTypes: ItticReservationType[]
    }>(ITTIC_REERVATION_TYPES, {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only'
    })

  useEffect(() => {
    if (showReservationType) {
      getItticReservationTypes({ variables: { tenantCode: 102 } })
    }
  }, [showReservationType])

  const isPersianName = persianRegex.test(
    confirmPrimitiveInput.booker.firstName
  )
  const isPersianLastName = persianRegex.test(
    confirmPrimitiveInput.booker.lastName
  )

  const allowedEmailRegex = /^[A-Za-z0-9._@-]*$/

  // Proper email format (no Persian or weird characters)
  const strictEmailFormatRegex =
    /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/

  return (
    <div className={classes.formContainer}>
      <Typography variant="h4" className={classes.header}>
        {getTranslate('The Booker Information')}
      </Typography>
      <div className={classes.row}>
        <InputWithLabel
          name="firstName"
          autoComplete="given-name"
          label={getTranslate('First Name')}
          className={classes.input}
          style={isPersianName ? { fontFamily: 'IranSans' } : undefined}
          value={confirmPrimitiveInput.booker.firstName}
          onChange={(e) => {
            const value = e.currentTarget.value
            setConfirmPrimitiveInput({
              ...confirmPrimitiveInput,
              booker: {
                ...confirmPrimitiveInput.booker,
                firstName: value
              }
            })
          }}
          helpertext={
            !(confirmPrimitiveInput.booker.isForeigner
              ? englishRegex.test(confirmPrimitiveInput.booker.firstName)
              : persianLetterRegex.test(
                  confirmPrimitiveInput.booker.firstName
                )) && confirmPrimitiveInput.booker.firstName.length > 0
              ? confirmPrimitiveInput.booker.isForeigner
                ? getTranslate(
                    'Only English letters are allowed for foreign guests'
                  )
                : getTranslate('Just Enter Persian Letters')
              : ''
          }
          error={
            !(confirmPrimitiveInput.booker.isForeigner
              ? englishRegex.test(confirmPrimitiveInput.booker.firstName)
              : persianLetterRegex.test(
                  confirmPrimitiveInput.booker.firstName
                )) && confirmPrimitiveInput.booker.firstName.length > 0
          }
        />
        <InputWithLabel
          name="lastName"
          autoComplete="family-name"
          label={getTranslate('Last Name')}
          className={classes.input}
          style={isPersianLastName ? { fontFamily: 'IranSans' } : undefined}
          value={confirmPrimitiveInput.booker.lastName}
          onChange={(e) => {
            const value = e.currentTarget.value
            setConfirmPrimitiveInput({
              ...confirmPrimitiveInput,
              booker: {
                ...confirmPrimitiveInput.booker,
                lastName: value
              }
            })
          }}
          helpertext={
            !(confirmPrimitiveInput.booker.isForeigner
              ? englishRegex.test(confirmPrimitiveInput.booker.lastName)
              : persianLetterRegex.test(
                  confirmPrimitiveInput.booker.lastName
                )) && confirmPrimitiveInput.booker.lastName.length > 0
              ? confirmPrimitiveInput.booker.isForeigner
                ? getTranslate(
                    'Only English letters are allowed for foreign guests'
                  )
                : getTranslate('Just Enter Persian Letters')
              : ''
          }
          error={
            !(confirmPrimitiveInput.booker.isForeigner
              ? englishRegex.test(confirmPrimitiveInput.booker.lastName)
              : persianLetterRegex.test(
                  confirmPrimitiveInput.booker.lastName
                )) && confirmPrimitiveInput.booker.lastName.length > 0
          }
        />
        <InputWithLabel
          name="email"
          autoComplete="email"
          label={getTranslate('Email')}
          className={classes.input}
          type="email"
          value={confirmPrimitiveInput.booker.email}
          error={
            !strictEmailFormatRegex.test(confirmPrimitiveInput.booker.email) &&
            confirmPrimitiveInput.booker.email.length > 0
          }
          helpertext={
            !strictEmailFormatRegex.test(confirmPrimitiveInput.booker.email) &&
            confirmPrimitiveInput.booker.email.length > 0
              ? getTranslate(
                  'Email address must contain only English letters, numbers, and have a valid format.'
                )
              : ''
          }
          onChange={(e) => {
            const value = e.currentTarget.value
            if (!allowedEmailRegex.test(value)) return
            setConfirmPrimitiveInput({
              ...confirmPrimitiveInput,
              booker: { ...confirmPrimitiveInput.booker, email: value }
            })
          }}
        />
      </div>
      <div className={classes.row}>
        <InputWithLabel
          name="phone"
          autoComplete="tel"
          label={getTranslate('Mobile Number')}
          type="number"
          value={confirmPrimitiveInput.booker.mobile}
          min={0}
          onKeyDown={(e) => {
            if (e.key === '-' || e.key === 'e' || e.key === '.') {
              e.preventDefault()
            }
          }}
          error={
            confirmPrimitiveInput.booker.mobile.length > 0 &&
            !iranMobileRegex.test(confirmPrimitiveInput.booker.mobile)
          }
          helpertext={
            confirmPrimitiveInput.booker.mobile.length > 0 &&
            !iranMobileRegex.test(confirmPrimitiveInput.booker.mobile)
              ? getTranslate('Please enter a valid phone numbers')
              : ''
          }
          onChange={(e) => {
            const rawValue = e.currentTarget.value

            if (elevenNumbersOnlyRegex.test(rawValue)) {
              setConfirmPrimitiveInput({
                ...confirmPrimitiveInput,
                booker: {
                  ...confirmPrimitiveInput.booker,
                  mobile: rawValue
                }
              })
            }
          }}
          placeholder={getTranslate('Type only numbers')}
          className={[classes.input, classes.inputNumber].join(' ')}
        />
        <InputWithLabel
          name="national-id"
          value={confirmPrimitiveInput.booker.identificationNo}
          label={getTranslate(
            `${
              confirmPrimitiveInput.booker.isForeigner
                ? 'Passport Number'
                : 'ID Card Number'
            }`
          )}
          error={
            confirmPrimitiveInput.booker.identificationNo.length > 0 &&
            !validateIdentificationNo(
              confirmPrimitiveInput.booker.identificationNo.slice(0, 10),
              confirmPrimitiveInput.booker.isForeigner
            )
          }
          helpertext={
            confirmPrimitiveInput.booker.identificationNo.length > 0 &&
            !validateIdentificationNo(
              confirmPrimitiveInput.booker.identificationNo.slice(0, 10),
              confirmPrimitiveInput.booker.isForeigner
            )
              ? confirmPrimitiveInput.booker.isForeigner
                ? getTranslate(
                    'Please enter a valid passport number (6–9 alphanumeric).'
                  )
                : getTranslate('The national ID must be 10 digits and valid.')
              : ''
          }
          type="text"
          min={0}
          placeholder={getTranslate('Type only numbers')}
          onKeyDown={(e) => {
            if (
              e.key === '-' ||
              e.key === 'e' ||
              e.key === '+' ||
              e.key === '.'
            ) {
              e.preventDefault()
            }
          }}
          className={[classes.input, classes.inputNumber].join(' ')}
          onChange={(event) => {
            const rawInput = event.currentTarget.value
            const inputValue = rawInput.replace(/\s+/g, '')

            if (
              tenNumbersOnlyRegex.test(inputValue) ||
              confirmPrimitiveInput.booker.isForeigner
            ) {
              setConfirmPrimitiveInput({
                ...confirmPrimitiveInput,
                booker: {
                  ...confirmPrimitiveInput.booker,
                  identificationNo: inputValue
                }
              })
            }
          }}
        />
        {showReservationType && (
          <SelectWithLabel
            label={getTranslate('Reservation Type')}
            placeholder={getTranslate('Choose reservation type')}
            size="small"
            className={classes.input}
            onChange={(e) =>
              setConfirmPrimitiveInput({
                ...confirmPrimitiveInput,
                itticReservationType: {
                  ID:
                    itticReservationTypes?.getItticReservationTypes.find(
                      (type) => type.code === Number(e.target.value)
                    )?.ID || '',
                  code: Number(e.target.value),
                  name: itticReservationTypes?.getItticReservationTypes.find(
                    (type) => type.code === Number(e.target.value)
                  )?.name || { en: '', fa: '' }
                }
              })
            }>
            {itticReservationTypes?.getItticReservationTypes.map(
              (item, index) => (
                <MenuItem key={index} value={item.code}>
                  {lang === 'fa' ? item.name.fa : item.name.en}
                </MenuItem>
              )
            )}
          </SelectWithLabel>
        )}
      </div>
      <div className={classes.row}>
        {showDiscount && (
          <InputWithLabel
            label={getTranslate('Discount')}
            className={classes.input}
            type="number"
            min={0}
            onKeyDown={(e) => {
              if (e.key === '-' || e.key === 'e' || e.key === '+') {
                e.preventDefault()
              }
            }}
            placeholder={getTranslate('Type only numbers')}
            onChange={(e) => {
              const value = e.currentTarget.value
              setConfirmPrimitiveInput({
                ...confirmPrimitiveInput,
                discountPercent: value === '' ? 0 : Number(value)
              })
            }}
          />
        )}
      </div>
      <div>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              size="small"
              onChange={(e) => setFillBookerDetalisEnabled(e.target.checked)}
            />
          }
          label={getTranslate('Fill booker detail as guest detail')}
          classes={{ label: classes.label }}
        />
      </div>
    </div>
  )
}

export default BookerDetailsForm
